import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoyaltyCardHomingService } from '../../../../services/loyalty/loyalty-card-homing.service';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-loyalty-card-homing-form',
  templateUrl: './loyalty-card-homing-form.component.html',
  styleUrls: ['./loyalty-card-homing-form.component.css']
})
export class LoyaltyCardHomingFormComponent implements OnInit {
  public labels: any = {};
  public operationType: string;
  public startingCardNumber: string = null;
  public endingCardNumber: string = null;
  public storeFrom: {label: string, value: number};
  public storeTo: {label: string, value: number};
  public allStores: {label: string, value: number}[]= [];
  public sameLoyaltyStores: {label: string, value: number}[] = [];

  alertMsg: string;

  constructor(
    private translate: TranslateService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private cardHomingService: LoyaltyCardHomingService,
    private storeService: StoreCommonService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    this.translate.get('cardHoming').subscribe(res => this.labels = res);
    this.translate.get('cardHoming.alertMsg').subscribe(res => this.alertMsg = res);
    this.operationType = this.activatedRoute.snapshot.queryParamMap.get('operationType');
  }

  validateNumber(event) {
    const keyCode = event.keyCode;
    const excludedKeys = [8, 9, 37, 39, 46];
    if (!((keyCode >= 48 && keyCode <= 57) ||
      (keyCode >= 96 && keyCode <= 105) ||
      (excludedKeys.indexOf(keyCode) != -1))) {
      event.preventDefault();
    }
  }

  searchAllStores(event) {
    setTimeout(
     () => this.storeService.getStoreByName(event.query).subscribe(res => this.allStores = res), 1000
    )
  }

  searchLoyaltyStores(event) {
    setTimeout(
      () => this.storeService.getStoresByChannel(event.query, this.storeFrom).then(res => this.sameLoyaltyStores = res), 1000
    )
  }

  confirm() {
    if (+this.endingCardNumber > +this.startingCardNumber) {
      let cardsQty: number = +this.endingCardNumber - +this.startingCardNumber;
      this.translate.get('cardHoming.confirmMsg', {cardsQty: cardsQty + 1, startingCardNumber: this.startingCardNumber})
      .subscribe(confirmMsg => {
        this.confirmationService.confirm({
          message: confirmMsg,
          accept: () => this.cardHoming(),
          acceptLabel: 'Ok',
          rejectLabel: 'Annulla'
        })
      })
    } else {
      this.confirmationService.confirm({
        message: this.alertMsg,
        accept: () => false,
        acceptLabel: 'Ok',
        rejectVisible: false
      })
    }
  }

  cardHoming() {
    let params: { store_src_id: number, store_dest_id: number, card_no_start: string, card_no_end: string, operation_type: number };
    params = {
      store_src_id: +this.storeFrom.value,
      store_dest_id: +this.storeTo.value,
      card_no_start: this.startingCardNumber && this.startingCardNumber.length == 13 ? this.startingCardNumber.slice(0, -1) : this.startingCardNumber,
      card_no_end: this.endingCardNumber && this.endingCardNumber.length == 13 ? this.endingCardNumber.slice(0, -1) : this.endingCardNumber,
      operation_type: +this.operationType
    }
    this.cardHomingService.postCardHoming(params).subscribe(
      res => res,
      error => console.error(error),
      () => this.route.navigate(['/loyalty/card-homing'])
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-homing/loyalty-card-homing-form/loyalty-card-homing-form.component.ts